import Scriba from 'react-scriba';

export class DataTicket {

    static _chargementListeDesTicketsDeLaTache = (filtres, tri, nbreEnreg) => {
        const objet = { ...filtres, tri, nbreEnreg };
        const url = "api/Liste/ListeDesTicketsDeLaTache";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementFicheTicket(idTicket) {
        let objet = {
            "idTicket": idTicket
        };

        var url = "api/Fiche/FicheTicket";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementTicket(idTicket, idTache, ticket, fileData) {
        let objet = {
            "idTicket": idTicket,
            "idTache": idTache,
            "ticket": ticket,
            "fileData": fileData
        };

        var url = "api/MAJDonnees/EnregistrementTicket";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionTicket(idTicket) {
        let objet = {
            "idTicket": idTicket,
        };

        var url = "api/MAJDonnees/SuppressionTicket";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementLoginCompteDesTickets(listIdTickets) {
        let objet = {
            "listIdTickets": listIdTickets
        }

        var url = "api/Get/GetLoginCompteDesTickets";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementStatutTicket(listIdTickets, statut) {
        let objet = {
            "listIdTickets": listIdTickets,
            "statut": statut
        };
        var url = "api/MAJDonnees/EnregistrementStatutTicket";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };
    /* 20230306 : YD : renommage DesactivationTicket en DossiociationTicket */
    static _onEnregistrementDissociationTicket(listIdTickets) {
        let objet = {
            "listIdTickets": listIdTickets
        };
        var url = "api/MAJDonnees/EnregistrementDissociationTicket";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementRaccrochementTicketsATache(idTache, listIdTickets) {
        let objet = {
            "idTache": idTache,
            "listIdTickets": listIdTickets
        };
        var url = "api/MAJDonnees/EnregistrementRaccrochementTicketsATache";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementAssignationTicket(assigneA, listIdTickets) {
        let objet = {
            "assigneA": assigneA,
            "listIdTickets": listIdTickets
        };
        var url = "api/MAJDonnees/EnregistrementAssignationTicket";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementEtatTicket(idEtat, listIdTickets) {
        let objet = {
            "idEtat": idEtat,
            "listIdTickets": listIdTickets
        };
        var url = "api/MAJDonnees/EnregistrementEtatTicket";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionTicketHistorique(idTicketHistorique) {
        var objet = {
            "idTicketHistorique": idTicketHistorique
        }

        var url = "api/MAJDonnees/SuppressionTicketHistorique";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesHistoriques(idTicket, tri, filtres) {
        const objet = { idTicket, tri, filtres };
        const url = "api/Liste/ListeDesTicketHistoriques";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementFicheTicketHistorique(idTicketHistorique) {
        let objet = {
            "idTicketHistorique": idTicketHistorique
        };

        var url = "api/Fiche/FicheTicketHistorique";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementTicketHistorique(objet) {
        var url = "api/MAJDonnees/EnregistrementTicketHistorique";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementDesProjetsHub() {
        let objet = {};
        var url = "api/Liste/ListeDesProjetsHub";

        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementDesTachesHub(idProjet, phase) {
        let objet = {
            "idProjet": idProjet,
            "phase": phase
        };
        var url = "api/Liste/ListeDesTachesHub";

        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementDesPhasesHub(idProjet) {
        let objet = {
            "idProjet": idProjet,
        };
        var url = "api/Liste/ListeDesPhasesHub";

        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementDesEvenementsHub(idTicket) {
        let objet = {
            "idTicket": idTicket,
        };
        var url = "api/Liste/ListeDesEvenementsHub";

        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheEvenementHub(idTicket, idEvenement) {
        let objet = {
            "idTicket": idTicket,
            "idEvenement": idEvenement,
        };
        var url = "api/Fiche/FicheEvenementHub";

        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementTachePhaseHub(idProjet) {
        let objet = {
            "idProjet": idProjet,
        };
        var url = "api/Fiche/GetTachePhaseDuProjetHub";

        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementEvenementHub(evenement) {
        let objet = {
            "evenement": evenement
        };

        var url = "api/MAJDonnees/EnregistrementEvenementHub";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    };
}